import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';

import { giftCodeApi as api } from 'api/giftCodes';
import { FormComponent, Notifications } from 'shared';

function CreateSystemGiftCodes() {
    const [notification, setNotification] = useState({ text: null, level: null });

    const formFields = [
        {
            name: 'amount',
            inputElement: 'textField',
            label: 'Amount',
            gridValue: 6,
            inputProps: { type: 'number', integer: false, required: true },
        },
        {
            name: 'numCreate',
            inputElement: 'textField',
            label: 'Number to create',
            gridValue: 6,
            inputProps: { type: 'number', integer: true, required: true },
        },
    ];

    return (
        <div>
            <h1>Create gift codes</h1>
            <Notifications options={notification} />
            {}
            <div>
                <FormComponent
                    formFields={formFields}
                    onSubmit={async (formData, resetForm) => {
                        const response = await api.createCodes(formData);
                        if (response.status === false) {
                            setNotification({ text: `Unable to create codes ${response.msg}`, level: 'error' });
                            return;
                        }

                        setNotification({ text: 'Success!', level: 'success' });
                        resetForm();
                    }}
                />
            </div>
        </div>
    );
}

export { CreateSystemGiftCodes };
